export default "__VITE_ASSET__Aq76ZajT__"